import React from 'react';
import {
  FlightTakeoff,
  Map,
  Cloud,
  Assessment,
  Security,
  Speed
} from '@mui/icons-material';
import styles from '../../styles/FeatureShowcase.module.css';

const FeatureShowcase = () => {
  const features = [
    {
      icon: FlightTakeoff,
      title: 'LAANC Authorizations',
      description: 'Instant airspace authorizations in controlled airspace via FAA LAANC integration.',
      color: '#0066cc'
    },
    {
      icon: Map,
      title: 'Mission Planning',
      description: 'Plan and manage flight missions with interactive mapping and geofencing tools.',
      color: '#008000'
    },
    {
      icon: Cloud,
      title: 'Cloud Storage',
      description: 'Secure cloud storage for flight logs, mission data, and compliance documentation.',
      color: '#9c27b0'
    },
    {
      icon: Assessment,
      title: 'Fleet Analytics',
      description: 'Track drone performance, maintenance schedules, and operational metrics.',
      color: '#ff6f00'
    },
    {
      icon: Security,
      title: 'Compliance Tools',
      description: 'Stay compliant with automated regulatory checks and audit logs.',
      color: '#d32f2f'
    },
    {
      icon: Speed,
      title: 'Real-time Tracking',
      description: 'Monitor active flights and receive instant alerts for airspace changes.',
      color: '#0288d1'
    }
  ];

  return (
    <section className={styles['feature-showcase']} aria-labelledby="features-heading">
      <div className={styles['showcase-header']}>
        <h2 id="features-heading" className={styles['showcase-title']}>
          Platform Features
        </h2>
        <p className={styles['showcase-description']}>
          Comprehensive tools for drone operations, fleet management, and regulatory compliance
        </p>
      </div>

      <div className={styles['features-grid']} role="list">
        {features.map((feature, index) => {
          const IconComponent = feature.icon;
          return (
            <article
              key={index}
              className={styles['feature-card']}
              role="listitem"
            >
              <div
                className={styles['feature-icon-wrapper']}
                style={{ backgroundColor: `${feature.color}15` }}
                aria-hidden="true"
              >
                <IconComponent
                  className={styles['feature-icon']}
                  style={{ color: feature.color }}
                  fontSize="large"
                />
              </div>
              <h3 className={styles['feature-title']}>
                {feature.title}
              </h3>
              <p className={styles['feature-description']}>
                {feature.description}
              </p>
            </article>
          );
        })}
      </div>

      <div className={styles['showcase-footer']}>
        <p className={styles['footer-note']}>
          All plans include access to core platform features with varying usage limits.
        </p>
      </div>
    </section>
  );
};

export default FeatureShowcase;
